// @flow

import {getUrl} from './utils/get-url';
import type {PrintFile} from './typedef';

const WINDOW_OPTIONS = 'scrollbars=1, menubar=1, resizable=1, width=780, height=800, left=120, top=80';

export const printFile: PrintFile = (callInfo, apiRoot) => new Promise((resolve, reject) => {
    const url = getUrl(callInfo, apiRoot);

    const printWindow = window.open(url, 'printWindow', WINDOW_OPTIONS);
    const onLoad = () => {
        printWindow.print();
        resolve({
            type: callInfo.types[1]
        });
        printWindow.removeEventListener('load', onLoad);
    };

    const onError = () => {
        reject({
            type: callInfo.types[2]
        });
        printWindow.removeEventListener('error', onError);
    };

    if (printWindow) {
        printWindow.addEventListener('load', onLoad);
        printWindow.addEventListener('error', onError);
    } else {
        reject({
            type: callInfo.types[2],
            error: 'Failed to open print window'
        });
    }
});

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./typedef");
